import React, { useState, useEffect } from "react";
import { Breadcrumb, Typography, theme, Modal, Table, Button, Input, Form, DatePicker, Select, App, Dropdown, Switch } from "antd";
import moment from "moment";
import esES from "antd/locale/es_ES";
import dayjs from "dayjs";
import { MoreOutlined, EditOutlined, DeleteOutlined, CalendarOutlined, FilterOutlined } from "@ant-design/icons";
import { useAuth } from "../../context/AuthProvider";
import { getBackendUrl } from '../../utils/env';
import ForbiddenPage from "../Status/ForbiddenPage";
import axios from "axios";
moment.locale("es");
const { Title, Paragraph } = Typography;

export default function AdminEventsDashboard() {
    const { message, modal } = App.useApp();
    const { user } = useAuth();
    const { token } = theme.useToken();
    const [activities, setActivities] = useState([]);
    const [editingEvent, setEditingEvent] = useState(null);
    const [events, setEvents] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedActivities, setSelectedActivities] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    // Usamos un Watch para reaccionar al estado del Switch en tiempo real
    const isAllDay = Form.useWatch('is_all_day', form);

    useEffect(() => {
        if (user?.id === 1) {

            fetchActivities();
            fetchCategories();
            fetchEvents();
        }
    }, []);

    // Bloqueo de seguridad por rol/ID
    if (user?.id !== 1) {
        return <ForbiddenPage />;
    }



    const fetchActivities = () => {
        axios.get(`${getBackendUrl()}api/admin/activities.php`)
            .then(res => {
                if (res.data.success) {
                    setActivities(res.data.activities);
                } else {
                    message.error("No se pudieron cargar las actividades");
                }
            })
            .catch(() => message.error("Error al cargar las actividades"));
    };

    const fetchCategories = () => {
        axios.get(`${getBackendUrl()}api/admin/categories.php`)
            .then(res => {
               // console.log("Respuesta de categorías:", res); // Log para depuración
                if (res.data.success) {
                    setCategories(res.data.categories);
                } else {
                    message.error("No se pudieron cargar las categorías");
                }
            })
            .catch(() => message.error("Error al cargar las categorías"));
    };

    const fetchEvents = () => {
        axios.get(`${getBackendUrl()}api/admin/events.php`)
            .then(res => {
                // res.data es el JSON de PHP; res.data.data es el array de eventos
                if (res.data && res.data.success) {
                    setEvents(res.data.data);
                } else {
                    message.error(res.data.message || "No se pudieron cargar los eventos");
                }
            })
            .catch(err => {
                console.error(err);
                message.error("Error al cargar los eventos");
            });
    };

    const filteredEvents = selectedActivities.length
        ? events.filter(e => selectedActivities.includes(e.activity_id))
        : events;
    // Estado para controlar un modal controlado (más escalable)




    // Al hacer clic en "Nuevo Evento"
    const handleNewEventClick = () => {
        setEditingEvent(null);
        form.resetFields();
        setIsModalOpen(true);
    };

    // Al hacer clic en "Editar" desde la tabla
    const handleEditClick = (event) => {
        setEditingEvent(event);

        // Mapeamos los datos de la BD (snake_case) al formulario de AntD (camelCase)
        // Nota: Si usas Day.js/Moment, debes envolver la fecha para que el DatePicker la lea
        form.setFieldsValue({
            eventName: event.event_name,
            description: event.description,
            activity: event.activity_id,
            category: event.category_id,
            location: event.location,
            date: dayjs(event.event_date), // o moment(event.event_date) dependiendo de tu librería
            is_all_day: event.is_all_day === 1 // Convertimos el valor numérico a booleano para el Switch
        });

        setIsModalOpen(true);
    };

    // Al cerrar o cancelar el modal
    const handleCloseModal = () => {
        form.resetFields();
        setEditingEvent(null);
        setIsModalOpen(false);
    };

    const handleSaveEvent = async () => {
        try {
            const values = await form.validateFields();
            let eventDate = values.date;

            if (values.is_all_day) {
                // Forzamos que guarde las 00:00:00 del día seleccionado
                eventDate = eventDate.startOf('day');
            }
            const payload = {
                eventName: values.eventName,
                description: values.Description || "", // Asegurarse de enviar una cadena vacía si no se proporciona descripción
                category: values.category,
                activity: "1", // Fijo por ahora, ya que no se muestra en el formulario
                location: values.location,
                date: values.date.format("YYYY-MM-DD HH:mm:ss"),
                event_date: eventDate.format('YYYY-MM-DD HH:mm:ss'),
                is_all_day: values.is_all_day ? 1 : 0 // Guardar bandera en DB
            };
            console.log("Payload antes de enviar al backend:", payload); // Log para depuración

            const config = {
                headers: { 'Authorization': `Bearer ${token}` }
            };

            if (editingEvent) {
                //  MODO EDICIÓN: Petición PUT
                payload.id = editingEvent.id; // Inyectamos el ID que pide el backend

                const res = await axios.put(`${getBackendUrl()}api/admin/events.php`, payload, config);
                //console.log("Respuesta del backend:", res); // Log para depuración
                //console.log("Payload enviado:", payload); // Log para depuración
                if (res.data.success) {
                    message.success("Evento actualizado con éxito");
                    handleCloseModal();
                    fetchEvents();
                } else {
                    message.error(res.data.message || "No se pudo actualizar el evento");
                }

            } else {
                //  MODO CREACIÓN: Petición POST
                const res = await axios.post(`${getBackendUrl()}api/admin/events.php`, payload, config);

                if (res.data.success) {
                    message.success("Evento creado con éxito");
                    handleCloseModal();
                    fetchEvents();
                } else {
                    message.error(res.data.message || "No se pudo crear el evento");
                }
            }
        } catch (error) {
            console.error("Error al procesar formulario:", error);
            console.log("Error en la validación del formulario:", error);
            message.error("Por favor, verifica los campos del formulario", error);
        }
    };


    const handleDeleteEvent = (id) => {
        modal.confirm({
            title: "¿Estás seguro de eliminar este evento?",
            content: "Esta acción no se puede deshacer.",
            okText: "Sí, eliminar",
            okType: "danger",
            cancelText: "Cancelar",
            mask: true,
            onOk() {
                return axios.delete(`${getBackendUrl()}api/admin/events.php`, { params: { id } })
                    .then(res => {
                        if (res.data.success) {
                            message.success("Evento eliminado");
                            fetchEvents(); // Refrescar la tabla
                        } else {
                            message.error(res.data.message || "No se pudo eliminar el evento");
                        }
                    })
                    .catch(() => message.error("Error al conectar con el servidor"));
            }
        });
    };


    const exportToCalendar = (record) => {
        const eventTitle = record.event_name;
        const eventLocation = record.location || "Sin ubicación";
        const eventDescription = record.description || "";

        // 1. Crear el objeto Date inicial a partir de la fecha de la base de datos
        // Reemplazamos el espacio por 'T' para asegurar compatibilidad con el constructor de Date
        const startDateObj = new Date(record.event_date.replace(" ", "T"));

        // 2. Calcular la fecha de fin sumándole EXACTAMENTE 2 horas de manera segura
        const endDateObj = new Date(startDateObj.getTime() + (2 * 60 * 60 * 1000));

        // Función interna para formatear la fecha al estándar estricto de iCal (YYYYMMDDTHHMMSS)
        // Nota: No agregamos la 'Z' al final para que actúe como "Hora Local Estática" en el celular
        const formatToiCalDate = (date) => {
            const pad = (num) => String(num).padStart(2, '0');
            return [
                date.getFullYear(),
                pad(date.getMonth() + 1),
                pad(date.getDate()),
                'T',
                pad(date.getHours()),
                pad(date.getMinutes()),
                pad(date.getSeconds())
            ].join('');
        };

        const dateStart = formatToiCalDate(startDateObj);
        const dateEnd = formatToiCalDate(endDateObj);

        // 3. Construir la estructura limpia del estándar iCalendar
        const icsStructure = [
            "BEGIN:VCALENDAR",
            "VERSION:2.0",
            "PRODID:-//Sentinel//Eventos//ES",
            "CALSCALE:GREGORIAN",
            "BEGIN:VEVENT",
            `UID:${record.id}-${Date.now()}@sentinel.com`,
            `DTSTAMP:${formatToiCalDate(new Date())}`,
            `DTSTART:${dateStart}`,
            `DTEND:${dateEnd}`,
            `SUMMARY:${eventTitle}`,
            `DESCRIPTION:${eventDescription}`,
            `LOCATION:${eventLocation}`,
            "END:VEVENT",
            "END:VCALENDAR"
        ].join("\r\n");

        // 4. Crear el archivo en memoria y forzar la descarga
        const blob = new Blob([icsStructure], { type: "text/calendar;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${eventTitle.replace(/\s+/g, "_")}.ics`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    // Columnas  para la tabla de eventos
    const columns = [
        {
            title: 'Evento',
            dataIndex: 'event_name',
            key: 'event_name',
            render: (text) => (
                <div>
                    <div
                        style={{
                            fontWeight: 600,
                            fontSize: 15
                        }}
                    >
                        {text}
                    </div>
                </div>
            )
        },
        { title: 'Actividad', dataIndex: 'category_name', key: 'category_name' },
        {
            title: 'Descripción', dataIndex: 'description', key: 'description', render: (text) => (
                <Paragraph ellipsis={{ rows: 2, expandable: true, symbol: 'Leer más' }}>
                    {text || "Sin descripción"}
                </Paragraph>
            )
        },
        
        {
            title: 'Fecha',
            dataIndex: 'event_date',
            key: 'event_date',
            render: (_, record) => (
    <div>
        <div style={{ fontWeight: 600 }}>
            {moment(record.event_date).format('dddd, DD MMM')}
        </div>

        <div
            style={{
                color: token.colorTextSecondary,
                fontSize: 13
            }}
        >
            {record.all_day
                ? '📅 Todo el día'
                : moment(record.event_date).format('hh:mm A')}
        </div>
    </div>
)
        },

        { title: 'Ubicación', dataIndex: 'location', key: 'location' },
        {
            title: 'Acciones',
            key: 'actions',
            fixed: 'right',
            width: 60, //  Ahora es súper delgada, ideal para celulares
            align: 'center',
            render: (_, record) => {
                // Definimos el menú de opciones
                const menuItems = [
                    {
                        key: 'edit',
                        label: 'Editar',
                        icon: <EditOutlined />,
                        onClick: () => handleEditClick(record)
                    },
                    {
                        key: 'calendar',
                        label: 'Agregar a calendario',
                        icon: <CalendarOutlined />,
                        onClick: () => exportToCalendar(record)
                    },
                    {
                        type: 'divider', // Línea divisoria estética antes de eliminar
                    },
                    {
                        key: 'delete',
                        label: 'Eliminar',
                        icon: <DeleteOutlined />,
                        danger: true, // Lo pinta de rojo automáticamente
                        onClick: () => handleDeleteEvent(record.id)
                    }
                ];

                return (
                    <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
                        <Button
                            type="text"
                            icon={<MoreOutlined style={{ fontSize: 18 }} />}
                            size="large"
                            style={{
                                borderRadius: 12,
                                transition: 'all 0.2s ease'
                            }}
                        />
                    </Dropdown>
                );
            }
        }
    ];

    return (
        <div
            style={{
                padding: 'clamp(16px, 4vw, 32px)',
                maxWidth: 1280,
                margin: '0 auto',
                minHeight: '100vh',
                background: token.colorBgLayout
            }}
        >
            {/* Breadcrumb */}
            <Breadcrumb
                style={{ marginBottom: 24 }}
                items={[
                    { title: <span style={{ color: token.colorTextDescription }}>Inicio</span> },
                    { title: "Panel de Administración" },
                    { title: "Eventos" },
                ]}
            />

            {/* Header */}
            <section
                style={{
                    marginBottom: 32,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 16
                }}
            >
                <div>
                    <Title level={2} style={{ marginBottom: 4 }}>
                        Gestión de Eventos
                    </Title>

                    <Paragraph
                        style={{
                            margin: 0,
                            color: token.colorTextSecondary,
                            fontSize: 15
                        }}
                    >
                        {events.length} eventos registrados
                    </Paragraph>
                </div>

                <Button
                    type="primary"
                    size="large"
                    icon={<CalendarOutlined />}
                    onClick={handleNewEventClick}
                    style={{
                        borderRadius: 12,
                        height: 48,
                        paddingInline: 24,
                        fontWeight: 600,
                        boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
                        display: window.innerWidth > 768 ? 'flex' : 'none'
                    }}
                >
                    Nuevo Evento
                </Button>
            </section>

            <div
                style={{
                    background: token.colorBgContainer,
                    borderRadius: 20,
                    padding: 20,
                    marginBottom: 24,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
                }}
            >
                <Paragraph
                    strong
                    style={{ marginBottom: 12 }}
                >
                    Filtrar por actividad
                </Paragraph>

                <Select
                    placeholder="Selecciona actividades"
                    mode="multiple"
                    allowClear
                    options={categories.map(cat => ({
                        label: cat.name,
                        value: cat.id
                    }))}

                    suffixIcon={<FilterOutlined />}
                    style={{ width: '100%' }}
                    size="large"
                    value={selectedActivities}
                    onChange={(value) => setSelectedActivities(value)}
                />
            </div>



            {/* Tabla de Datos */}
            <div
                style={{
                    background: token.colorBgContainer,
                    borderRadius: 20,
                    overflow: 'hidden',
                    boxShadow: '0 2px 12px rgba(0,0,0,0.04)'
                }}
            >
                <Table
                    columns={columns}
                    dataSource={filteredEvents}
                    rowKey="id"
                    size="middle"
                    pagination={{
                        pageSize: 8,
                        showSizeChanger: false
                    }}
                    scroll={{ x: 'max-content' }}
                    locale={{
                        emptyText: (
                            <div style={{ padding: '48px 0' }}>
                                <div style={{ fontSize: 48 }}>📅</div>

                                <Paragraph
                                    style={{
                                        marginTop: 12,
                                        color: token.colorTextSecondary
                                    }}
                                >
                                    No hay eventos registrados
                                </Paragraph>
                            </div>
                        )
                    }}
                />
            </div>

            {/* Modal de Creación Modificado a Componente */}
            <Modal
                title={
                    <div>
                        <Title level={4} style={{ margin: 0 }}>
                            {editingEvent ? 'Editar evento' : 'Nuevo evento'}
                        </Title>

                        <Paragraph
                            style={{
                                margin: 0,
                                color: token.colorTextSecondary
                            }}
                        >
                            Completa la información del evento
                        </Paragraph>
                    </div>
                }
                open={isModalOpen}
                onOk={handleSaveEvent}
                onCancel={handleCloseModal}
                okText={editingEvent ? 'Guardar cambios' : 'Crear evento'}
                cancelText="Cancelar"
                width={720}
            >
                <Form form={form} layout="vertical" name="create_event_form" style={{ marginTop: 16 }}>
                    <div style={{ marginBottom: 24 }}>
                        <Title level={5}>Información General</Title>
                        <Form.Item
                            name="eventName"
                            label="Nombre del evento"
                            rules={[{ required: true, message: 'Por favor, ingresa el nombre del evento' }]}
                        >
                            <Input
                                placeholder="Ej. Formación Sabatina"
                                size="large"
                                allowClear
                                style={{ borderRadius: 12 }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="Description"
                            label="Descripción"
                        >
                            <Input.TextArea
                                placeholder="Describe el evento..."
                                allowClear
                                autoSize={{ minRows: 4, maxRows: 6 }}
                                style={{ borderRadius: 12 }}
                            />
                        </Form.Item>
                    </div>
                    <div>
                        <Title level={5}>Detalles del Evento</Title>
    
                        <Form.Item
                            name="category"
                            label="Actividad del evento"
                            rules={[{ required: true, message: 'Por favor, ingresa la actividad del evento' }]}
                        >
                            <Select
                                placeholder="Selecciona una actividad"
                                options={categories.map(cat => ({
                                    label: cat.name,
                                    value: cat.id
                                }))}
                            />
                        </Form.Item>
                        <Form.Item
                            name="date"
                            label={isAllDay ? "Fecha del evento" : "Fecha y hora del evento"}
                            rules={[{ required: true, message: 'Por favor, ingresa la fecha' }]}
                        >
                            <DatePicker
                                format={isAllDay ? "DD/MM/YYYY" : "DD/MM/YYYY HH:mm"}
                                showTime={isAllDay ? false : { format: 'HH:mm' }}
                                locale={esES}
                                size="large"
                                style={{ width: '100%', borderRadius: 12 }}
                                inputReadOnly
                                disabledDate={(current) => current && current < dayjs().startOf('day')}

                                // AQUÍ METEMOS EL SWITCH DENTRO DEL DESPLEGABLE
                                renderExtraFooter={() => (
                                    <div style={{ padding: "8px 12px", borderTop: `1px solid ${token.colorBorderSecondary}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span style={{ fontSize: 13, color: token.colorTextSecondary }}>¿Dura todo el día?</span>
                                        <Form.Item name="is_all_day" valuePropName="checked" noStyle>
                                            <Switch size="small" />
                                        </Form.Item>
                                    </div>
                                )}
                            />
                        </Form.Item>
                        <Form.Item
                            name="location"
                            label="Ubicación"
                            initialValue="Parroquia San Francisco de Asís" 
                            rules={[{ required: true, message: 'Por favor, ingresa la ubicación del evento' }]}
                        >
                            <Input allowClear />
                        </Form.Item>
                    </div>
                </Form>
            </Modal>
            <Button
                type="primary"
                shape="circle"
                icon={<CalendarOutlined />}
                size="large"
                onClick={handleNewEventClick}
                style={{
                    position: 'fixed',
                    bottom: 24,
                    right: 24,
                    width: 60,
                    height: 60,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                    marginBottom: 90,
                   
                }}
            />
        </div>
    );
}
